import React, { useContext } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { headerLabelStyle, headerValueStyle } from './BillingStyles';

const BillingPlanInfo = ({ campaign, billingInfo, forwardScheduleData }) => {
    // Styles
    const infoContainerStyle = {
        display: 'flex',
        width: '100%'
    };
    const infoColumnContainerStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    };
    const infoItemContainerStyle = {
        display: 'flex',
        height: 20,
        paddingBottom: 10
    };
    const itemLabelStyle = {
        ...headerLabelStyle,
        width: 150
    };
    const itemValueStyle = {
        ...headerValueStyle,
        paddingRight: 2
    };

    // State
    const { formatCurrency } = useContext(SystemSettingsContext);

    const stilToBill = forwardScheduleData?.length > 0 ? forwardScheduleData?.map(fs => fs?.airtimeValue + fs?.offAirsValue).reduce((a, b) => a + b) : 0;

    return (
        <div style={infoContainerStyle}>
            <div style={infoColumnContainerStyle}>
                <div style={infoItemContainerStyle}>
                    <div style={itemLabelStyle}>
                        {window.translate('Campaign Budget')}
                    </div>
                    <div style={itemValueStyle}>
                        {formatCurrency(campaign?.budget)}
                    </div>
                </div>

                <div style={infoItemContainerStyle}>
                    <span style={itemLabelStyle}>
                        {window.translate('Airtime Spend')}
                    </span>
                    <span style={itemValueStyle}>
                        {formatCurrency(billingInfo?.airtimeSpend)}
                    </span>
                </div>

                <div style={infoItemContainerStyle}>
                    <span style={itemLabelStyle}>
                        {window.translate('Off-Air Spend')}
                    </span>
                    <span style={itemValueStyle}>
                        {formatCurrency(billingInfo?.offairSpend)}
                    </span>
                </div>
            </div>

            <div style={infoColumnContainerStyle}>
                <div style={infoItemContainerStyle}>
                    <span style={itemLabelStyle}>
                        {window.translate('Total Invoiced')}
                    </span>
                    <span style={itemValueStyle}>
                        {formatCurrency(billingInfo?.invoiceTotal)}
                    </span>
                </div>

                <div style={infoItemContainerStyle}>
                    <span style={itemLabelStyle}>
                        {window.translate('Total Credits')}
                    </span>
                    <span style={itemValueStyle}>
                        {formatCurrency(billingInfo?.creditTotal)}
                    </span>
                </div>

                <div style={{ width: 240, height: 20 }}>
                    <span style={itemLabelStyle}>
                        {window.translate('Total Still to Bill')}
                    </span>
                    <span style={{...itemValueStyle, marginRight: stilToBill <= 0 ? 79 : 13}}>
                        {formatCurrency(stilToBill)}
                    </span>
                </div>
            </div>

            <div style={{ ...infoColumnContainerStyle }}>
                <div style={infoItemContainerStyle}>
                    <span style={itemLabelStyle}>
                        {window.translate('Billing Plan')}
                    </span>
                    <span style={itemValueStyle}>
                        {window.translate(campaign?.billingTermName)}
                    </span>
                </div>

                <div style={infoItemContainerStyle}>
                    <span style={itemLabelStyle}>
                        {window.translate('Billing Contact')}
                    </span>
                    <span style={itemValueStyle}>
                        {window.translate(billingInfo?.billingContactName)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default BillingPlanInfo;
